import { Priceable } from "./Types";
import { Quotation } from "../../stores/CoursePreviewStore/Types";

export const formatCourses = courses =>
  courses.map(course => ({
    text: course.name,
    value: course.slug,
    key: course.slug
  }));

export const formatCountries = countries =>
  countries.map(country => ({
    text: country.country,
    value: country.code,
    key: country.code
  }));

export const canShowCoursePaymentToggle = ({
  priceable,
  fullPaymentQuote,
  paymentPlanQuote,
}: {
  priceable?: Priceable | null;
  fullPaymentQuote?: Quotation | null;
  paymentPlanQuote?: Quotation | null;
}) => {
  if (!priceable || priceable.sample) return false;
  if (!fullPaymentQuote || !paymentPlanQuote) return false;

  return fullPaymentQuote.amount > 0 && paymentPlanQuote.amount > 0;
};

// How many whole monthly payments a yearly Pass quote saves on its list price:
// 2 when it is the standard "2 months free", 0 when the saving is something
// else and should be described in money instead. Always 0 with a voucher or
// referral code: a 10% or 20% code also comes to whole months against the
// full price ("3 months free"), but the code comes off the monthly payments
// too, so that would be the code and the offer mixed together.
export const monthsSaved = (quote?: Quotation | null, instalments = 12): number => {
  if (quote?.code_applied || quote?.coupon_code) return 0;

  const originalCents = quote?.original_price?.cents;
  if (!originalCents || originalCents <= 0) return 0;

  const months = (originalCents - (quote?.fractional || 0)) / (originalCents / instalments);
  const whole = Math.round(months);
  return whole > 0 && Math.abs(months - whole) < 0.01 ? whole : 0;
};

// The whole-number percentage a quote has come down from its list price. Works
// off what is actually being charged rather than a literal, because a voucher
// can take more than the standard discount -- a free-course code takes all of
// it -- and a summary that said "save 15%" to someone paying nothing was the
// bug that taught us that.
export const savingPercent = (quote?: Quotation | null): number => {
  const originalCents = quote?.original_price?.cents;
  if (!originalCents || originalCents <= 0) return 0;

  return Math.round(
    ((originalCents - (quote?.fractional || 0)) / originalCents) * 100,
  );
};
